import { extractMenu } from '@/utils/extract'
import { expandURI } from '@/utils/ajax'

export const recordLockMixin = {
  data() {
    return {
      umenu: {}
    }
  },
  methods: {
    // AR: OS-660 Added to check record lock 2021-01-21
    async initCommonUtilMenu() {
      const apiURI = this.$store.state.app.menu.commonUtility
      if (apiURI) {
        try {
          const result = await this.$http.get(apiURI)
          const { data } = result
          if (data) {
            this.umenu = extractMenu(data._links)
          }
        } catch (err) {
          //
        }
      }
    },
    async checkRecordLock(recKey, recType) {
      const apiUrl = this.umenu.checkRecordLock
      let lockStatus = false
      if (apiUrl) {
        try {
          const params = {
            recKey: recKey,
            recType: recType
          }
          const result = await this.$http.get(expandURI(apiUrl, params))
          const { data } = result.data
          if (data) {
            // Record not locked and no exceptions
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          // Record was locked or with exceptions
          lockStatus = true
        }
      } else {
        lockStatus = true
      }
      return lockStatus
    },
    async unlockRecord(recKey, recType) {
      const apiUrl = this.umenu.unlockRecord
      if (apiUrl) {
        const expand = {
          recKey: recKey,
          recType: recType
        }
        this.$http.post(apiUrl, expand).then(result => {
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        })
      }
    }
  }
}
